import { gql } from '../types/generated';

export const UPDATE_PIPELINE_CONFIG = gql(`
  mutation updatePipelineConfig($teamId: Int!, $pipelineConfig: PipelineConfig!) {
    updatePipelineConfig(teamId: $teamId, pipelineConfig: $pipelineConfig) {
      ...PipelineConfigFields
    }
  }
`);
